import {
  FormFieldConfigType,
  INPUT_TYPES,
  TEXT_INPUT_TYPES,
} from "../../../../types";
import { PRODUCT_INFORMATION_CONSTANTS } from "../../../constants";
import { preProcessFormFields } from "../../../../tools";
import {
  AMAZON_MARKETPLACE_OPTIONS,
  FULFILMENT_PATH_OPTIONS,
} from "../../../options";

export const formFieldsConfig: FormFieldConfigType[] = [
  {
    name: "allProductInformationFields",
    type: INPUT_TYPES.FIELD_GROUP,
    contained: true,
    label: "Product Information",
    fields: [
      {
        name: PRODUCT_INFORMATION_CONSTANTS.COUNTRY_WHERE_ITEM_WAS_PURCHASED,
        label: "Country Where Item Was Purchased From (ie. amazon.fr)",
        description: "",
        placeholderText: "Select marketplace",
        type: INPUT_TYPES.SELECT,
        options: AMAZON_MARKETPLACE_OPTIONS,
      },
      {
        name: PRODUCT_INFORMATION_CONSTANTS.ORDER_ID,
        label: "Order ID",
        description: "",
        placeholderText: "Please enter Order ID",
        type: INPUT_TYPES.TEXT,
        textInputType: TEXT_INPUT_TYPES.DEFAULT,
      },
      {
        name: PRODUCT_INFORMATION_CONSTANTS.ASIN,
        label: "ASIN",
        description: "",
        placeholderText: "Please enter ASIN",
        type: INPUT_TYPES.TEXT,
        textInputType: TEXT_INPUT_TYPES.DEFAULT,
      },
      {
        name: PRODUCT_INFORMATION_CONSTANTS.PRODUCT_NAME,
        label: "Product Name",
        description: "",
        placeholderText: "Please enter Product Name",
        type: INPUT_TYPES.TEXT,
        textInputType: TEXT_INPUT_TYPES.DEFAULT,
      },
      {
        name: PRODUCT_INFORMATION_CONSTANTS.FULFILMENT_PATH,
        label: "Fulfilment Path",
        description: "",
        placeholderText: "Select Fulfilment Path",
        type: INPUT_TYPES.SELECT,
        options: FULFILMENT_PATH_OPTIONS,
      },
    ],
  },
];

export const formFieldsConfigProcessed = preProcessFormFields(formFieldsConfig);